import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import type { ReactElement } from 'react'
import { Button } from './ui/button'
import { Card } from './ui/card'

export interface UnsavedChangesDialogProps {
  isOpen: boolean
  title?: string
  description?: string
  confirmText?: string
  cancelText?: string
  onConfirm: () => void
  onCancel: () => void
}

export function UnsavedChangesDialog({
  isOpen,
  title = 'Unsaved Changes',
  description = 'You have unsaved changes. Are you sure you want to leave without saving? Your changes will be lost.',
  confirmText = 'Leave without saving',
  cancelText = 'Stay on page',
  onConfirm,
  onCancel,
}: UnsavedChangesDialogProps): ReactElement | null {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4">
      <Card className="w-full max-w-md border-amber-200 bg-white p-6 shadow-2xl">
        <div className="flex items-start gap-4">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-600">
            <ExclamationTriangleIcon className="h-6 w-6" aria-hidden="true" />
          </div>
          <div className="flex-1">
            <h3 className="font-semibold text-gray-900 text-lg">{title}</h3>
            <p className="mt-2 text-gray-600 text-sm">{description}</p>
          </div>
        </div>

        <div className="mt-6 flex flex-col-reverse justify-end gap-2 sm:flex-row">
          <Button
            type="button"
            variant="outline"
            onClick={onCancel}
            className="w-full sm:w-auto"
          >
            {cancelText}
          </Button>
          <Button
            type="button"
            onClick={onConfirm}
            className="w-full bg-red-600 text-white hover:bg-red-700 sm:w-auto"
          >
            {confirmText}
          </Button>
        </div>
      </Card>
    </div>
  )
}
